import {camelCase, upperFirst} from 'lodash'

import {
  stripAsyncActionNameSuffixes,
} from '../core/reduxUtils'

function generateDefaultInitialPendingState() {
  return {
    isGetCategoryBannersPending: false,
    isGetHomeFeatureTogglesPending: false,
    isGetSearchFeatureTogglesPending: false,
    isGetCategoryProductsPending: false,
    isGetSearchProductsPending: false,
    isGetNextSearchProductsPending: false,
    isGetNextCategoryProductsPending: false,
    isGetDealOfTheDayProductsPending: false,
    isGetCategoryFiltersPending: false,
    isAddToCartPending: false,
    isGetFiltersPending: false,
    isGetSearchFiltersPending: false,
    isGetNextFiltersPending: false,
    isGetNextSearchFiltersPending: false,
    isApplyFiltersPending: false,
    isApplySearchFiltersPending: false,
    isApplyTagFiltersPending: false,
    isGetSplitProductVariantsPending: false,
    isLoadMenuItemsPending: false,
    isGetChildMenuItemsPending: false,
    isGetMenuItemsPending: false,
    isGetTagProductsPending: false,
    isGetNextTagProductsPending: false,
    isGetCampaignsPending: false,
    isGetNextCampaignsPending: false,
    isGetLandingPageDetailPending: false,
    isGetLandingPagesInfoPending: false,
    isGetCmsComponentPending: false,
    isGetStaticPageInfoPending: false,
    isGetBrandProductsPending: false,
    isAddToCartProductDetailPending: false,
    isGetCampaignsPdpDashboardPending: true,
    isGetCustomerSpecialCampaignsPending: false,
  }
}
const PENDING_FLAG_PREFIX = 'is';
const PENDING_FLAG_SUFFIX = 'Pending';

function pendingReducer(state = generateDefaultInitialPendingState(), action) {
  let newState;

  if (action.type === 'SET_PENDING_STATE') {
    const {baseActionName} = stripAsyncActionNameSuffixes(action.payload.pendingState);
    const pendingFlagName = PENDING_FLAG_PREFIX + upperFirst(camelCase(baseActionName)) + PENDING_FLAG_SUFFIX;
    newState = {
      ...state,
      [pendingFlagName]: action.payload.status || false,
    };
  } else if (action.isAsync && action.pendingResult != null) {
    const {baseActionName} = stripAsyncActionNameSuffixes(action.type);
    const pendingFlagName = PENDING_FLAG_PREFIX + upperFirst(camelCase(baseActionName)) + PENDING_FLAG_SUFFIX;

    newState = {
      ...state,
      [pendingFlagName]: action.pendingResult,
    };
  } else {
    newState = state;
  }

  return newState;
}

export {generateDefaultInitialPendingState};
export default pendingReducer;
